export const dayOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const monthOfYear = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const shortMonthOfYear = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];
export const hackColors = {
  blue: "#0092CB",
  pink: "#C90F96",
  purple: "#4A338E",
};

export const LOADING_MESSAGE = {
  DASHBOARD: "Loading Dashboard",
  TOKEN_VALIDATION: "Validating",
  VIDEO_LIST: "Fetching Videos",
};
